import React from 'react'
import { Grid } from '@material-ui/core'
import BorderColorIcon from '@material-ui/icons/BorderColor'
import { useTranslation } from 'react-i18next'
import { AddressDataType } from '../../../components/shipping-address-form/shipping-address-form.hook'
import { useAddressStyles } from '../../../components/address-block/address-block.styles'

/* Address Inline Block */
type AddressInlineBlock = {
  address: AddressDataType
  setIsOpen: (value: boolean) => void
}

export const AddressInlineBlock: React.FC<AddressInlineBlock> = (props) => {
  const classes = useAddressStyles()
  const { address, setIsOpen } = props
  const { t } = useTranslation()

  return (
    <div className={classes.inlineBlock}>
      <Grid container item xs={12} spacing={2} justifyContent="flex-start">
        {/*Name*/}
        <Grid item xs={12} className={classes.nameLine}>
          <span>{address.name}</span>
          <div title={t('checkout.edit')} onClick={() => setIsOpen(true)}>
            <BorderColorIcon className={classes.icon} />
          </div>
        </Grid>

        {/*Address Line 1*/}
        <Grid item xs={12}>
          <span>{address.addressLine1}</span>
        </Grid>

        {/*Address Line 2*/}

        {!!address.addressLine2.length && (
          <Grid item xs={12}>
            <span>{address.addressLine2}</span>
          </Grid>
        )}

        {/*City*/}
        <Grid item xs={12}>
          <span>{address.city}</span>
        </Grid>

        {/*Postal Code*/}
        <Grid item xs={12}>
          <span>
            {address.region}, {address.postalCode}, {address.countryCode}
          </span>
        </Grid>
      </Grid>
    </div>
  )
}
